import { Injectable } from '@angular/core';
import { PartnerMaintenanceController } from './PartnerMaintenanceController';


@Injectable()
export class PartnerFreightForwarderMaintenanceController extends
    PartnerMaintenanceController {

    public getResourceRoot(): string {
        return "PARTNER.FREIGHTFORWARDER";
    }

    public buildUrl(uri: string): string {
        return "/system/partner/freight-forwarder" + uri;
    }

    public getPermission(): string[] {
        return ["PARTNER.FREIGHTFORWARDER.LINKPERMISSION.FILTER"];
    }
}
